import React, { useEffect, useState } from "react";
import { CircularProgress, Skeleton } from "@mui/material";
import { withTranslation } from "react-i18next";
import BtnOutline from "../../../components/button/BtnOutline";
import "../process.css";
import { useLocation } from "react-router-dom";
import { Date as CustomDate, DateTerminal } from "../../../utils/moment";
import {
  calculateAmmount,
  formatDateTime,
  formatDateTimeWithIcons,
  getTimeDifferenceFromStartOfMonth,
} from "../../../utils/utility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
import Nodata from "../../../components/Nodata";
import urlResolver from "../../../utils/urlResolver";
import { API_PATH } from "../../../constant/apiPath";
import instance from "../../../api/interceptor";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

const ShipmentDetailsCard = ({
  detailsdata,
  loading,
  t,
  shipmentType,
  transportData,
  shipmentDetailsLoading,
  terminalData,
  cabotagemData,
}) => {
  const [showmore, setShowmore] = useState(true);
  const [isCopied, setIsCopied] = useState(false);
  const [nodata, setNoData] = useState(true);
  const [carbonLoading, setCarbonLoading] = useState(false);
  const [carbonData, setCarbonData] = useState({});
  const [tempCarbonData, setTempCarbonData] = useState(null);

  const [pickupInfo, setPickupInfo] = useState({});
  const location = useLocation();

  console.log("shipmentType", shipmentType);

  const clickShowmore = () => {
    showmore ? setShowmore(false) : setShowmore(true);
  };
  useEffect(() => {
    if (
      !Object.keys(detailsdata).length &&
      !Object.keys(transportData)?.length
    ) {
      setNoData(true);
      setCarbonData({});
    } else {
      setNoData(false);
      if (!tempCarbonData && detailsdata?.CarbonEmissionAmount) {
        setCarbonData({
          amount: detailsdata.CarbonEmissionAmount,
          unit: detailsdata.CarbonEmissionUnit,
        });
      }
    }
  }, [detailsdata, tempCarbonData]);
  useEffect(() => {
    if (tempCarbonData) {
      setCarbonData(tempCarbonData);
    } else {
      setCarbonData({});
    }
  }, [tempCarbonData]);
  useEffect(() => {
    setShowmore(true);
  }, [detailsdata]);

  const poNumberSplit = (poNum) => {
    if (poNum?.split(",")?.length > 2) {
      let tempPoNum = poNum.split(",");
      let orderRef = tempPoNum.join(", ");
      return <p className="test-para">{orderRef ?? "N/A"}</p>;
    } else {
      return (
        <p className="test-para">{detailsdata?.OrderReference ?? "N/A"}</p>
      );
    }
  };

  const poNumberSplitTransport = (poNum) => {
    if (poNum?.split(",")?.length > 2) {
      let tempPoNum = poNum.split(",");
      let orderRef = tempPoNum.join(", ");
      return <p className="test-para">{orderRef ?? "N/A"}</p>;
    } else {
      return <p className="test-para">{transportData?.JobNumber ?? "N/A"}</p>;
    }
  };

  const getVesselVoyageText = (vessel, voyage, t) => {
    if (!vessel && !voyage) {
      return t("N/A");
    }
    return `${vessel ?? ""}${vessel && voyage ? "-" : ""}${voyage ?? ""}`;
  };

  const getLoadDischargeText = (loadPort, discharge, voyage, t) => {
    if (!loadPort && !discharge && !voyage) {
      return t("N/A");
    }
    return `${loadPort ?? ""}${loadPort || discharge ? " ✈ " : ""}${
      discharge ?? ""
    }${(loadPort || discharge) && voyage ? ", " : ""}${voyage ?? ""}`;
  };

  const shipmentNumber = detailsdata?.ShipmentID;
  const getCarbonData = (shipmentNumber) => {
    setCarbonLoading(true);
    setTempCarbonData(null);
    const url = `${API_PATH.CARBONDATA}/${shipmentNumber}`;
    instance
      .get(url)
      .then((res) => {
        const newCarbonData = res._Data?.mass || null;
        setTempCarbonData(newCarbonData);
      })
      .catch((err) => {
        console.log("error", err);
        setTempCarbonData(null);
      })
      .finally(() => {
        setCarbonLoading(false);
      });
  };

  useEffect(() => {
    const tempPickupInfo = Array.isArray(transportData?.transportContainerLegs)
      ? transportData.transportContainerLegs[0]
      : null;

    setPickupInfo(tempPickupInfo);
  }, [transportData?.transportContainerLegs]);

  return (
    <>
      {loading || shipmentDetailsLoading ? (
        <Skeleton
          variant="rectangular"
          height={365}
          style={{ width: "100%", marginBottom: "1rem" }}
        />
      ) : (
        <>
          <div className="mid-container-process d-flex">
            {nodata ? (
              <Nodata />
            ) : shipmentType === "Shipment" ? (
              <>
                <div className="process-page-image d-flex">
                  {location?.state?.item?.TransportMode === "SEA" ? (
                    <img src={urlResolver("icon/SEABACKGROUNDBLUE.svg")} />
                  ) : location?.state?.item?.TransportMode === "AIR" ? (
                    <img src={urlResolver("icon/AIRBACKGROUNDBLUE.svg")} />
                  ) : location?.state?.item?.TransportMode === "ROA" ? (
                    <img src={urlResolver("icon/ROADBACKGROUNDBLUE.svg")} />
                  ) : null}
                  <div>
                    <h3 className="test-head">{t("PONumber")}</h3>
                    {poNumberSplit(detailsdata?.OrderReference)}
                  </div>
                </div>
                <div className="test-section ">
                  <div>
                    <h4 className="test-section-head">{t("ETD")} </h4>
                    <p className=" test-section-para">
                      {CustomDate(detailsdata?.ETD ?? null)}
                    </p>
                  </div>
                  <div>
                    <h4 className="test-section-head">{t("ETA")}</h4>
                    <p className="test-section-para">
                      {CustomDate(detailsdata?.ETA ?? null)}
                    </p>
                  </div>
                </div>
              </>
            ) : shipmentType === "Terminal" ? (
              <div className="process-page-image d-flex">
                <img src={urlResolver("icon/TERMINALBLUE.svg")} />

                <div>
                  <h3 className="test-head">{t("PONumber")}</h3>
                  {poNumberSplit(terminalData?.PONumber ?? null)}
                </div>
              </div>
            ) : shipmentType === "Transport" ? (
              <>
                <div className="process-page-image d-flex">
                  {location?.state?.item?.TransportMode === "SEA" ? (
                    <img src={urlResolver("icon/SEABACKGROUNDBLUE.svg")} />
                  ) : location?.state?.item?.TransportMode === "AIR" ? (
                    <img src={urlResolver("icon/AIRBACKGROUNDBLUE.svg")} />
                  ) : location?.state?.item?.TransportMode === "ROA" ? (
                    <img src={urlResolver("icon/ROADBACKGROUNDBLUE.svg")} />
                  ) : null}
                  <div>
                    <h3 className="test-head">{t("Port Transport")}</h3>

                    {poNumberSplitTransport(transportData?.JobNumber ?? null)}
                  </div>
                  <div></div>
                </div>
                <div className="test-section ">
                  <div>
                    <h4 className="test-section-head">{t("Est. Pick Up")} </h4>
                    <p className=" test-section-para">
                      {CustomDate(transportData?.EstimatedPickup ?? null)}
                    </p>
                  </div>
                  <div>
                    <h4 className="test-section-head">{t("Est. Delivery")}</h4>
                    <p className="test-section-para">
                      {CustomDate(transportData?.EstimatedDelivery ?? null)}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="process-page-image d-flex no-shipment-type-po-wrap">
                  <img
                    alt="cabotagem"
                    src={urlResolver("icon/cabotagem.svg")}
                  />
                  <div className="no-shipment-type-po-wrap">
                    <h3 className="no-shipment-type-po-head">
                      {t("PONumber")}
                    </h3>
                    <p
                      className="no-shipment-type-po-value"
                      title={cabotagemData?.OrderReferences ?? "N/A"}
                    >
                      {cabotagemData?.OrderReferences?.split(",")?.length > 2
                        ? cabotagemData.OrderReferences.split(",").join(", ")
                        : (cabotagemData?.OrderReferences ?? "N/A")}
                    </p>
                  </div>
                </div>
                <div className="no-shipment-type-etd-eta">
                  <div>
                    <h4 className="no-shipment-type-etd-eta-label">
                      {t("ETD")}
                    </h4>
                    <p className="no-shipment-type-etd-eta-value">
                      {CustomDate(cabotagemData?.ETD ?? null)}
                    </p>
                  </div>
                  <div>
                    <h4 className="no-shipment-type-etd-eta-label">
                      {t("ETA")}
                    </h4>
                    <p className="no-shipment-type-etd-eta-value">
                      {CustomDate(cabotagemData?.ETA ?? null)}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
          {nodata ? (
            <Nodata />
          ) : shipmentType === "Shipment" ? (
            <div className="last-container">
              <div>
                <p className="carbon-head">
                  {carbonLoading ? (
                    <CircularProgress color="success" size="20px" />
                  ) : carbonData && carbonData.amount ? (
                    <span>
                      {carbonData.amount} {carbonData.unit}
                    </span>
                  ) : (
                    ""
                  )}
                  <button
                    title="Calculate Emission"
                    style={{ border: "none", backgroundColor: "transparent" }}
                    onClick={() => {
                      getCarbonData(detailsdata?.ShipmentID);
                    }}
                  >
                    <img src={urlResolver("icon/co2.svg")} />
                  </button>
                </p>
              </div>

              <div className="last-container-first-child">
                <div className="d-flex " style={{ flexWrap: "wrap" }}>
                  <div className="last-container-child">
                    <p className="last-container-paraone2">{t("Shipper")}</p>
                    <p
                      className="color-blue2 last-container-childmid"
                      title={detailsdata?.ConsignorName ?? t("N/A")}
                    >
                      {detailsdata?.ConsignorName ?? t("N/A")}
                    </p>
                  </div>
                </div>
                <div className="d-flex " style={{ flexWrap: "wrap" }}>
                  <div
                    className={
                      location?.state?.item?.TransportMode === "AIR"
                        ? "d-none"
                        : "last-sectionlast"
                    }
                  >
                    {location?.state?.item?.TransportMode === "AIR" ? null : (
                      <>
                        <p className="last-container-paraone2">
                          {t("Mercante Number")}
                        </p>
                        <p
                          className="color-blue2 last-container-childmid"
                          title={detailsdata?.CEMercanteNumber ?? t("N/A")}
                        >
                          {detailsdata?.CEMercanteNumber ?? t("N/A")}
                          {detailsdata.CEMercanteNumber ? (
                            <>
                              <span
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    detailsdata?.CEMercanteNumber ?? t("N/A"),
                                  );
                                  setIsCopied(!isCopied);
                                }}
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "10px",
                                }}
                              >
                                {isCopied ? (
                                  <ContentCopyTwoToneIcon />
                                ) : (
                                  <ContentCopyIcon />
                                )}
                              </span>
                            </>
                          ) : null}
                        </p>
                      </>
                    )}
                  </div>

                  <div className="last-sectionlast">
                    <p className="last-container-paraone2">{t("Origin")}</p>
                    <p
                      className="color-blue2 last-container-childmid"
                      title={`${detailsdata?.OriginPortName ?? t("N/A")} , ${
                        detailsdata?.OriginCountryName ?? t("N/A")
                      }`}
                    >
                      {`${detailsdata?.OriginPortName ?? t("N/A")} , ${
                        detailsdata?.OriginCountryName ?? t("N/A")
                      }`}
                    </p>
                  </div>
                  <div className="last-sectionlast">
                    <p className="last-container-paraone2">
                      {t("Destination")}
                    </p>
                    <p
                      className="color-blue2 last-container-childmid"
                      title={`${
                        detailsdata?.DestinationPortName ?? t("N/A")
                      }, ${detailsdata?.DestinationCountryName ?? t("N/A")}`}
                    >{`${detailsdata?.DestinationPortName ?? t("N/A")}, ${
                      detailsdata?.DestinationCountryName ?? t("N/A")
                    }`}</p>
                  </div>

                  {!showmore ? (
                    <>
                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {t("ShipmentNumber")}:{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={detailsdata?.ShipmentID ?? t("N/A")}
                        >
                          {detailsdata?.ShipmentID ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {t("House Bill of Lading")}{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={detailsdata?.HouseBillNumber ?? t("N/A")}
                        >
                          {detailsdata?.HouseBillNumber ?? t("N/A")}
                        </p>
                      </div>
                      <div
                        className={
                          location?.state?.item?.TransportMode === "SEA"
                            ? "d-none"
                            : "last-sectionlast"
                        }
                      >
                        <p className="last-container-paraone">
                          {location.state.item.TransportMode === "SEA"
                            ? null
                            : "Master Airway Bill Number :"}
                        </p>
                        {location.state.item.TransportMode === "SEA" ? null : (
                          <p
                            className="last-container-childmid"
                            title={detailsdata?.MasterBillNumber ?? t("N/A")}
                          >
                            {detailsdata?.MasterBillNumber ?? t("N/A")}
                          </p>
                        )}
                      </div>
                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {" "}
                          {t("ContainerMode")}:{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={detailsdata?.ContainerMode ?? t("N/A")}
                        >
                          {detailsdata?.ContainerMode ?? t("N/A")}
                        </p>
                      </div>
                      {location.state.item.TransportMode === "AIR" ? null : (
                        <>
                          <div className="last-sectionlast">
                            <p className="last-container-paraone">
                              {t("ContainerCount")}:{" "}
                            </p>
                            <p
                              className="last-container-childmid text-ellipsis"
                              title={
                                detailsdata?.ContainerTypeCount ?? t("N/A")
                              }
                            >
                              {detailsdata?.ContainerTypeCount ?? t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast">
                            <p className="last-container-paraone">
                              {t("ContainerNumbers")}:{" "}
                            </p>
                            <p
                              className="last-container-childmid-container text-ellipsis"
                              title={detailsdata?.ContainerNumbers ?? t("N/A")}
                            >
                              {detailsdata?.ContainerNumbers ?? t("N/A")}
                            </p>
                          </div>
                        </>
                      )}

                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {t("LocalClient")}:{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={detailsdata?.LocalClientName ?? t("N/A")}
                        >
                          {detailsdata?.LocalClientName ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {t("Consignee")}:{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={detailsdata?.ConsigneeName ?? t("N/A")}
                        >
                          {detailsdata?.ConsigneeName ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {location.state.item.TransportMode === "SEA"
                            ? t("Carrier")
                            : t("Airline")}
                          :
                        </p>
                        <p
                          className="last-container-childmid"
                          title={detailsdata?.CarrierName ?? t("N/A")}
                        >
                          {detailsdata?.CarrierName ?? t("N/A")}
                        </p>
                      </div>
                      {location.state.item.TransportMode === "AIR" ? null : (
                        <>
                          {location.state.item.TransportMode ===
                          "SEA" ? null : (
                            <div className="last-sectionlast">
                              <p className="last-container-paraone">
                                {location.state.item.TransportMode === "SEA"
                                  ? "Voyage:"
                                  : "Flight"}
                                :
                              </p>
                              <p className="last-container-childmid">
                                {detailsdata?.Voyage ?? t("N/A")}
                              </p>
                            </div>
                          )}
                        </>
                      )}

                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {t("Weight")}:{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={`${detailsdata?.Weight ?? t("N/A")} ${
                            detailsdata?.WeightUnit ?? t("N/A")
                          }`}
                        >
                          {detailsdata?.Weight
                            ? `${
                                calculateAmmount(detailsdata?.Weight) ??
                                t("N/A")
                              } ${detailsdata?.WeightUnit ?? t("N/A")}`
                            : ""}
                        </p>
                      </div>

                      <div className="last-sectionlast">
                        <p className="last-container-paraone">
                          {t("Volume")}:{" "}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={`${detailsdata?.Volume ?? t("N/A")} ${
                            detailsdata?.VolumeUnit ?? t("N/A")
                          }`}
                        >
                          {detailsdata?.Volume
                            ? `${
                                calculateAmmount(detailsdata?.Volume) ??
                                t("N/A")
                              } ${detailsdata?.VolumeUnit ?? t("N/A")}`
                            : ""}
                        </p>
                      </div>

                      <div
                        className={
                          location?.state?.item?.TransportMode === "SEA" &&
                          detailsdata?.DemurrageFreeTime > 0
                            ? "last-sectionlast 55"
                            : "d-none"
                        }
                      >
                        <p className="last-container-paraone">
                          {location.state.item.TransportMode === "SEA" &&
                          detailsdata?.DemurrageFreeTime > 0
                            ? "Free Time :"
                            : null}
                        </p>
                        {location.state.item.TransportMode === "SEA" ? (
                          <p
                            className="last-container-childmid"
                            title={detailsdata?.DemurrageFreeTime ?? t("N/A")}
                          >
                            {detailsdata?.DemurrageFreeTime > 0
                              ? detailsdata?.DemurrageFreeTime
                              : null}
                          </p>
                        ) : null}
                      </div>

                      {location.state.item.TransportMode === "AIR" ? null : (
                        <>
                          {location.state.item.TransportMode ===
                          "SEA" ? null : (
                            <div className="last-sectionlast d-none">
                              <p className="last-container-paraone">
                                {location.state.item.TransportMode === "SEA"
                                  ? t("Ship")
                                  : "Aircraft"}
                                :{" "}
                              </p>
                              <p
                                className="last-container-childmid"
                                title={`${detailsdata?.Vessel ?? t("N/A")}`}
                              >{`${detailsdata?.Vessel ?? t("N/A")}`}</p>
                            </div>
                          )}
                        </>
                      )}

                      {location.state.item.TransportMode === "AIR" ? (
                        <>
                          <div className="last-sectionlast ">
                            <p className="last-container-paraone">
                              {t("First Flight")}:
                            </p>
                            <p
                              className="last-container-childmid"
                              title={getLoadDischargeText(
                                detailsdata?.FirstLoadPortName,
                                detailsdata?.FirstDischargePortName,
                                detailsdata?.Voyage,
                                t,
                              )}
                            >
                              {getLoadDischargeText(
                                detailsdata?.FirstLoadPortCode,
                                detailsdata?.FirstDischargePortCode,
                                detailsdata?.Voyage,
                                t,
                              )}
                            </p>
                          </div>
                          <div className="last-sectionlast ">
                            <p className="last-container-paraone">
                              {t("Last Flight")}:
                            </p>
                            <p
                              className="last-container-childmid"
                              title={getLoadDischargeText(
                                detailsdata?.LastDischargePortName,
                                detailsdata?.LastLoadPortName,
                                detailsdata?.ArrivalVoyage,
                                t,
                              )}
                            >
                              {getLoadDischargeText(
                                detailsdata?.LastDischargePortCode,
                                detailsdata?.LastLoadPortCode,
                                detailsdata?.ArrivalVoyage,
                                t,
                              )}
                            </p>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="last-sectionlast ">
                            <p className="last-container-paraone">
                              {t("First Load Vessel")}:
                            </p>
                            <p
                              className="last-container-childmid"
                              title={getVesselVoyageText(
                                detailsdata?.Vessel,
                                detailsdata?.Voyage,
                                t,
                              )}
                            >
                              {getVesselVoyageText(
                                detailsdata?.Vessel,
                                detailsdata?.Voyage,
                                t,
                              )}
                            </p>
                          </div>
                          <div className="last-sectionlast ">
                            <p className="last-container-paraone">
                              {t("Arrival Vessel")}:
                            </p>
                            <p
                              className="last-container-childmid"
                              title={getVesselVoyageText(
                                detailsdata?.ArrivalVessel,
                                detailsdata?.ArrivalVoyage,
                                t,
                              )}
                            >
                              {getVesselVoyageText(
                                detailsdata?.ArrivalVessel,
                                detailsdata?.ArrivalVoyage,
                                t,
                              )}
                            </p>
                          </div>
                        </>
                      )}
                    </>
                  ) : null}
                </div>
              </div>
              <div className="d-flex justify-content-end buttonline">
                <BtnOutline
                  onClick={() => clickShowmore()}
                  title={showmore ? t("ShowMore") : t("ShowLess")}
                ></BtnOutline>
              </div>
            </div>
          ) : shipmentType === "Terminal" ? (
            <div className="last-container">
              <div className="last-container-first-child">
                <div className="terminal-grid ">
                  <div className="last-sectionlastTerminal">
                    <p className="last-container-paraone2">
                      {t("Container/Equipment/Qtd")}
                    </p>
                    <p
                      className="color-blue2 last-container-childmid"
                      title={terminalData?.ContainerNumbers ?? t("N/A")}
                    >
                      {terminalData?.ContainerNumbers ?? t("N/A")}
                    </p>
                  </div>
                  <div className="last-sectionlastTerminal">
                    <p className="last-container-paraone2">
                      {t("Lacre/Seal Number")}
                    </p>
                    <p
                      className="color-blue2 last-container-childmid"
                      title={terminalData?.SealNumbers ?? t("N/A")}
                    >
                      {terminalData?.SealNumbers ?? t("N/A")}
                    </p>
                  </div>

                  {!showmore ? (
                    <>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">{t("HBL")}</p>
                        <p
                          className="color-blue2 last-container-childmid"
                          title={terminalData?.HouseBillNumber ?? t("N/A")}
                        >
                          {terminalData?.HouseBillNumber ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">{t("Navio")}</p>
                        <p
                          className="last-container-childmid"
                          title={terminalData?.Vessel ?? t("N/A")}
                        >
                          {terminalData?.Vessel ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Data de Entrada Terminal")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={
                            terminalData?.CFSAvailable === "1900-01-01T00:00:00"
                              ? t("N/A")
                              : (DateTerminal(terminalData?.CFSAvailable) ??
                                t("N/A"))
                          }
                        >
                          {terminalData?.CFSAvailable === "1900-01-01T00:00:00"
                            ? t("N/A")
                            : (DateTerminal(terminalData?.CFSAvailable) ??
                              t("N/A"))}
                        </p>
                      </div>

                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Data Presença de Carga")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={
                            terminalData?.PDCDate === "1900-01-01T00:00:00"
                              ? t("N/A")
                              : (DateTerminal(terminalData?.PDCDate) ??
                                t("N/A"))
                          }
                        >
                          {terminalData?.PDCDate === "1900-01-01T00:00:00"
                            ? t("N/A")
                            : (DateTerminal(terminalData?.PDCDate) ?? t("N/A"))}
                        </p>
                      </div>

                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Data Desova")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={
                            terminalData?.UNPDate === "1900-01-01T00:00:00"
                              ? t("N/A")
                              : (DateTerminal(terminalData?.UNPDate) ??
                                t("N/A"))
                          }
                        >
                          {terminalData?.UNPDate === "1900-01-01T00:00:00"
                            ? t("N/A")
                            : (DateTerminal(terminalData?.UNPDate) ?? t("N/A"))}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">{t("DI")}</p>
                        <p
                          className="last-container-childmid"
                          title={terminalData?.DINote ?? t("N/A")}
                        >
                          {terminalData?.DINote ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">{t("DTA")}</p>
                        <p
                          className="last-container-childmid"
                          title={terminalData?.DTANote ?? t("N/A")}
                        >
                          {terminalData?.DTANote ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">{t("Shipper")}</p>
                        <p
                          className="last-container-childmid"
                          title={terminalData?.ShipperName ?? t("N/A")}
                        >
                          {terminalData?.ShipperName ?? t("N/A")}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Terminal Redestinação")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={terminalData?.CFSName ?? t("N/A")}
                        >
                          {terminalData?.CFSName ?? t("N/A")}
                        </p>
                      </div>

                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Terminal Atracação")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={terminalData?.CTOName ?? t("N/A")}
                        >
                          {terminalData?.CTOName ?? t("N/A")}
                        </p>
                      </div>

                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Data Registro Carga")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={
                            terminalData?.DataRegistroCarga ===
                            "1900-01-01T00:00:00"
                              ? t("N/A")
                              : (DateTerminal(
                                  terminalData?.DataRegistroCarga,
                                ) ?? t("N/A"))
                          }
                        >
                          {terminalData?.DataRegistroCarga ===
                          "1900-01-01T00:00:00"
                            ? t("N/A")
                            : (DateTerminal(terminalData?.DataRegistroCarga) ??
                              t("N/A"))}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Data Atracação Navio")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={
                            terminalData?.VesselArrival ===
                            "1900-01-01T00:00:00"
                              ? t("N/A")
                              : (DateTerminal(terminalData?.VesselArrival) ??
                                t("N/A"))
                          }
                        >
                          {terminalData?.VesselArrival === "1900-01-01T00:00:00"
                            ? t("N/A")
                            : (DateTerminal(terminalData?.VesselArrival) ??
                              t("N/A"))}
                        </p>
                      </div>
                      <div className="last-sectionlastTerminal">
                        <p className="last-container-paraone">
                          {t("Data Liberação Mapa")}
                        </p>
                        <p
                          className="last-container-childmid"
                          title={
                            terminalData?.MAPADate === "1900-01-01T00:00:00"
                              ? t("N/A")
                              : (DateTerminal(terminalData?.MAPADate) ??
                                t("N/A"))
                          }
                        >
                          {terminalData?.MAPADate === "1900-01-01T00:00:00"
                            ? t("N/A")
                            : (DateTerminal(terminalData?.MAPADate) ??
                              t("N/A"))}
                        </p>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="d-flex justify-content-end buttonline">
                <BtnOutline
                  onClick={() => clickShowmore()}
                  title={showmore ? t("ShowMore") : t("ShowLess")}
                ></BtnOutline>
              </div>
            </div>
          ) : shipmentType === "Transport" ? (
            <div className="last-container" style={{ padding: "14px" }}>
              <div>
                <div className="d-flex " style={{ flexWrap: "wrap" }}>
                  <div className="last-container-child">
                    <p className="last-container-paraone2">Pick up</p>
                    <p className="color-blue2 last-container-childmid">
                      <span>{pickupInfo?.PickupName || t("N/A")}</span>
                      <br />
                      <span>{pickupInfo?.PickupAddress || t("N/A")}</span>
                      <br />
                      <span>
                        {pickupInfo?.PickupAddress2 || t("N/A")} -{" "}
                        {pickupInfo?.PickupCity || t("N/A")}/
                        {pickupInfo?.PickupState || t("N/A")} - CEP:{" "}
                        {pickupInfo?.PickupPostCode || t("N/A")}
                      </span>
                      <br />
                      <br />
                      <span>{pickupInfo?.PickupCJN || t("N/A")}</span>
                    </p>
                  </div>
                </div>
                <div className="d-flex " style={{ flexWrap: "wrap" }}>
                  <div className="last-container-child">
                    <p className="last-container-paraone2">Delivery</p>
                    <p className="color-blue2 last-container-childmid">
                      <span>{pickupInfo?.DeliveryName || t("N/A")}</span>
                      <br />
                      <span>{pickupInfo?.DeliveryAddress || t("N/A")}</span>
                      <br />
                      <span>
                        {pickupInfo?.DeliveryAddress2 || t("N/A")} -{" "}
                        {pickupInfo?.DeliveryCity || t("N/A")}/
                        {pickupInfo?.DeliveryState || t("N/A")} - CEP:{" "}
                        {pickupInfo?.DeliveryPostCode || t("N/A")}
                      </span>
                      <br />
                      <br />
                      <span>{pickupInfo?.DeliveryCJN || t("N/A")}</span>
                    </p>
                  </div>
                </div>
              </div>
              {transportData?.ContainerMode === "CNT" && (
                <div className="last-container-first-child">
                  <p className="last-container-paraone2">Transport Job</p>
                  {transportData?.transportContainers?.map((item) => {
                    const transportLegs =
                      transportData?.transportContainerLegs?.find(
                        (transport) =>
                          transport.ContainerNum === item.ContainerNumber,
                      ) || {};
                    return (
                      <Accordion key={item.ContainerNumber}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandCircleDownOutlinedIcon
                              style={{ color: "var(--color-blue2)" }}
                            />
                          }
                          className="accordion-summary p-0"
                        >
                          <div className="text-with-line">
                            <p className="last-container-paraone2 m-0">
                              {item?.ContainerNumber || item?.ContainerQuality
                                ? `${item.ContainerNumber} ${item.ContainerQuality}`
                                : t("N/A")}
                            </p>
                          </div>
                        </AccordionSummary>

                        <AccordionDetails>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Container:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {item?.ContainerNumber || item?.ContainerQuality
                                ? `${item.ContainerNumber} ${item.ContainerQuality}`
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              NFE:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.Num_Doc_Orig ?? t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              CTE:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.NumCTE_AS ?? t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Veículo:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.Vehicle ?? t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Motorista:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.Driver ?? t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Retirada/Devolução do Container Vazio:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportData?.ContainerYardCity ?? t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Previsão de Coleta:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.PlannedPickupTime
                                ? formatDateTime(
                                    transportLegs?.PlannedPickupTime,
                                  )
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Chegada Coleta:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.PickupTimeIn
                                ? formatDateTime(transportLegs?.PickupTimeIn)
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Saída Coleta:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.PickupTimeOut
                                ? formatDateTime(transportLegs?.PickupTimeOut)
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Permanência:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.CartagePickupDemurrage
                                ? getTimeDifferenceFromStartOfMonth(
                                    transportLegs.CartagePickupDemurrage,
                                  )
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Previsão de Entrega:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.EstimatedDeliveryTime
                                ? formatDateTime(
                                    transportLegs.EstimatedDeliveryTime,
                                  )
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Chegada Entrega:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.DeliverTimeIn
                                ? formatDateTime(transportLegs.DeliverTimeIn)
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Saída Entrega:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.DeliverTimeOut
                                ? formatDateTime(transportLegs?.DeliverTimeOut)
                                : t("N/A")}
                            </p>
                          </div>
                          <div className="last-sectionlast-transport">
                            <p className="last-container-paraone2">
                              Permanência:&nbsp;
                            </p>
                            <p className="color-blue2 last-container-childmid">
                              {transportLegs?.CartageDeliveryDemurrage
                                ? getTimeDifferenceFromStartOfMonth(
                                    transportLegs.CartageDeliveryDemurrage,
                                  )
                                : t("N/A")}
                            </p>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </div>
              )}

              {transportData?.ContainerMode !== "CNT" && (
                <div className="last-container-first-child">
                  {transportData?.TransportLooseMoves?.map(
                    (looseMove, index) => {
                      const leg =
                        transportData?.transportContainerLegs?.[index] || {};
                      return (
                        <Accordion key={index}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandCircleDownOutlinedIcon
                                style={{ color: "var(--color-blue2)" }}
                              />
                            }
                            className="accordion-summary p-0"
                          >
                            <div className="text-with-line">
                              <p className="last-container-paraone2 m-0">
                                Carga Solta
                              </p>
                            </div>
                          </AccordionSummary>

                          <AccordionDetails>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Packs:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {looseMove?.BookedPackCount ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Type:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {looseMove?.PackType ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Weight:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {looseMove?.BookedWeight ?? t("N/A")}{" "}
                                {looseMove?.WeightUnit ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Volume:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {looseMove?.BookedVolume ?? t("N/A")}{" "}
                                {looseMove?.VolumeUnit ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                NFE:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.Num_Doc_Orig ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                CTE:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.NumCTE_AS ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Veículo:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.Vehicle ?? t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Previsão de Coleta:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.PlannedPickupTime
                                  ? formatDateTime(leg.PlannedPickupTime)
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Chegada Coleta:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.PickupTimeIn
                                  ? formatDateTime(leg.PickupTimeIn)
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Saída Coleta:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.PickupTimeOut
                                  ? formatDateTime(leg.PickupTimeOut)
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Permanência:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.CartagePickupDemurrage
                                  ? getTimeDifferenceFromStartOfMonth(
                                      leg?.CartagePickupDemurrage,
                                    )
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Previsão de Entrega:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.EstimatedDeliveryTime
                                  ? leg.EstimatedDeliveryTime.split(
                                      "T",
                                    )[1].slice(0, 5)
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Chegada Entrega:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.DeliverTimeIn
                                  ? formatDateTime(leg.DeliverTimeIn)
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Entrega:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.DeliverTimeOut
                                  ? formatDateTime(leg.DeliverTimeOut)
                                  : t("N/A")}
                              </p>
                            </div>
                            <div className="last-sectionlast-transport">
                              <p className="last-container-paraone2">
                                Permanência:&nbsp;
                              </p>
                              <p className="color-blue2 last-container-childmid">
                                {leg?.CartageDeliveryDemurrage
                                  ? getTimeDifferenceFromStartOfMonth(
                                      leg.CartageDeliveryDemurrage,
                                    )
                                  : t("N/A")}
                              </p>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      );
                    },
                  )}
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="no-shipment-type-card">
                <p className="no-shipment-type-title">Basic Registration</p>
                <div className="no-shipment-type-grid">
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">SHIPPER</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.ShipperName ?? t("N/A")}
                    >
                      {cabotagemData?.ShipperName ?? t("N/A")}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">CONSIGNEE</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.ConsigneeName ?? t("N/A")}
                    >
                      {cabotagemData?.ConsigneeName ?? t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">LOCAL CLIENT</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.LocalClientName ?? t("N/A")}
                    >
                      {cabotagemData?.LocalClientName ?? t("N/A")}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">HOUSE BILL</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.HouseBill ?? t("N/A")}
                    >
                      {cabotagemData?.HouseBill ?? t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">ORIGIN</p>
                    <p
                      className="no-shipment-type-value"
                      title={`${cabotagemData?.Origin ?? t("N/A")}`}
                    >
                      {`${cabotagemData?.Origin ?? t("N/A")}`}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">DESTINATION</p>
                    <p
                      className="no-shipment-type-value"
                      title={`${cabotagemData?.Destination ?? t("N/A")}`}
                    >
                      {`${cabotagemData?.Destination ?? t("N/A")}`}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">ETD</p>
                    <p
                      className="no-shipment-type-value"
                      title={CustomDate(cabotagemData?.ETD ?? null)}
                    >
                      {CustomDate(cabotagemData?.ETD ?? null)}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">ETA</p>
                    <p
                      className="no-shipment-type-value"
                      title={CustomDate(cabotagemData?.ETA ?? null)}
                    >
                      {CustomDate(cabotagemData?.ETA ?? null)}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">WEIGHT</p>
                    <p
                      className="no-shipment-type-value"
                      title={
                        cabotagemData?.ActualWeight !== null &&
                        cabotagemData?.ActualWeight !== undefined &&
                        cabotagemData?.ActualWeight !== "" &&
                        Number(cabotagemData?.ActualWeight) !== 0
                          ? `${calculateAmmount(cabotagemData.ActualWeight) ?? cabotagemData.ActualWeight}${
                              cabotagemData?.WeightUnit
                                ? ` ${cabotagemData.WeightUnit}`
                                : ""
                            }`
                          : t("N/A")
                      }
                    >
                      {cabotagemData?.ActualWeight !== null &&
                      cabotagemData?.ActualWeight !== undefined &&
                      cabotagemData?.ActualWeight !== "" &&
                      Number(cabotagemData?.ActualWeight) !== 0
                        ? `${calculateAmmount(cabotagemData.ActualWeight) ?? cabotagemData.ActualWeight}${
                            cabotagemData?.WeightUnit
                              ? ` ${cabotagemData.WeightUnit}`
                              : ""
                          }`
                        : t("N/A")}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">GOODS VALUE</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.GoodsValue ?? t("N/A")}
                    >
                      {cabotagemData?.GoodsValue ?? t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">DESCRIPTION</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.Description ?? t("N/A")}
                    >
                      {cabotagemData?.Description ?? t("N/A")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="no-shipment-type-card">
                <p className="no-shipment-type-title">Additional Detail</p>
                <div className="no-shipment-type-grid">
                  <p className="no-shipment-type-subheading">
                    Consolidation Details
                  </p>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">VOYAGE</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.Voyage ?? t("N/A")}
                    >
                      {cabotagemData?.Voyage ?? t("N/A")}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">VESSEL</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.Vessel ?? t("N/A")}
                    >
                      {cabotagemData?.Vessel ?? t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">ATD</p>
                    <p
                      className="no-shipment-type-value"
                      title={CustomDate(cabotagemData?.ATD ?? null)}
                    >
                      {CustomDate(cabotagemData?.ATD ?? null)}
                    </p>
                  </div>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">ATA</p>
                    <p
                      className="no-shipment-type-value"
                      title={CustomDate(cabotagemData?.ATA ?? null)}
                    >
                      {CustomDate(cabotagemData?.ATA ?? null)}
                    </p>
                  </div>

                  <p className="no-shipment-type-subheading">Organizations</p>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">CARRIER</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.Carrier ?? t("N/A")}
                    >
                      {cabotagemData?.Carrier ?? t("N/A")}
                    </p>
                  </div>

                  <p className="no-shipment-type-subheading">Departure</p>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">CTO</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.DepartureCTO ?? t("N/A")}
                    >
                      {cabotagemData?.DepartureCTO ?? t("N/A")}
                    </p>
                  </div>

                  <p className="no-shipment-type-subheading">Arrival</p>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">CTO</p>
                    <p
                      className="no-shipment-type-value"
                      title={cabotagemData?.ArrivalCTO ?? t("N/A")}
                    >
                      {cabotagemData?.ArrivalCTO ?? t("N/A")}
                    </p>
                  </div>

                  <p className="no-shipment-type-subheading">Container</p>
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">CONTAINER</p>
                    <p
                      className="no-shipment-type-value"
                      title={
                        cabotagemData?.Containers?.map(
                          (container) => container?.ContainerNumber || t("N/A"),
                        ).join(", ") || t("N/A")
                      }
                    >
                      {cabotagemData?.Containers?.map(
                        (container) => container?.ContainerNumber || t("N/A"),
                      ).join(", ") || t("N/A")}
                    </p>
                  </div>

                  {/* TYPE */}
                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">TYPE</p>
                    <p
                      className="no-shipment-type-value"
                      title={
                        cabotagemData?.Containers?.map(
                          (container) => container?.ContainerType || t("N/A"),
                        ).join(", ") || t("N/A")
                      }
                    >
                      {cabotagemData?.Containers?.map(
                        (container) => container?.ContainerType || t("N/A"),
                      ).join(", ") || t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">SEAL</p>
                    <p
                      className="no-shipment-type-value"
                      title={
                        cabotagemData?.Containers?.map(
                          (container) => container?.SealNumber || t("N/A"),
                        ).join(", ") || t("N/A")
                      }
                    >
                      {cabotagemData?.Containers?.map(
                        (container) => container?.SealNumber || t("N/A"),
                      ).join(", ") || t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">TARE WEIGHT</p>
                    <p
                      className="no-shipment-type-value"
                      title={
                        cabotagemData?.Containers?.map((container) => {
                          const weight = calculateAmmount(
                            container?.TareWeight,
                          );
                          const unit = container?.WeightUnit;

                          return weight
                            ? `${weight}${unit ? ` ${unit}` : ""}`
                            : t("N/A");
                        }).join(", ") || t("N/A")
                      }
                    >
                      {cabotagemData?.Containers?.map((container) => {
                        const weight = calculateAmmount(container?.TareWeight);
                        const unit = container?.WeightUnit;

                        return weight
                          ? `${weight}${unit ? ` ${unit}` : ""}`
                          : t("N/A");
                      }).join(", ") || t("N/A")}
                    </p>
                  </div>

                  <div className="no-shipment-type-field">
                    <p className="no-shipment-type-label">GOODS WGT.</p>

                    <p
                      className="no-shipment-type-value"
                      title={
                        cabotagemData?.Containers?.length
                          ? cabotagemData.Containers.map((container) => {
                              const rawWeight = container?.GoodsWeight;
                              const weight = calculateAmmount(rawWeight);
                              const unit = container?.WeightUnit;

                              const isValidWeight =
                                rawWeight !== null &&
                                rawWeight !== undefined &&
                                rawWeight !== "" &&
                                Number(rawWeight) !== 0;

                              return isValidWeight && weight
                                ? `${weight}${unit ? ` ${unit}` : ""}`
                                : t("N/A");
                            }).join(", ")
                          : t("N/A")
                      }
                    >
                      {cabotagemData?.Containers?.length
                        ? cabotagemData.Containers.map((container) => {
                            const rawWeight = container?.GoodsWeight;
                            const weight = calculateAmmount(rawWeight);
                            const unit = container?.WeightUnit;

                            const isValidWeight =
                              rawWeight !== null &&
                              rawWeight !== undefined &&
                              rawWeight !== "" &&
                              Number(rawWeight) !== 0;

                            return isValidWeight && weight
                              ? `${weight}${unit ? ` ${unit}` : ""}`
                              : t("N/A");
                          }).join(", ")
                        : t("N/A")}
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default withTranslation()(React.memo(ShipmentDetailsCard));
